import { FC } from "react";
import Badge from "@cloudscape-design/components/badge";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { UserGroup } from "../../../../../../domain/entities/UserProfileEntity";

interface GroupsDisplayProps {
    groups: UserGroup[];
}

const GroupsDisplay: FC<GroupsDisplayProps> = ({ groups }) => {
    if (!groups || groups.length === 0) {
        return <span>No groups assigned</span>;
    }

    return (
        <SpaceBetween direction="horizontal" size="xs">
            {groups.map((group) => (
                <Badge key={group.group_id}>{group.name}</Badge>
            ))}
        </SpaceBetween>
    );
};

export default GroupsDisplay;
